import {MovieDb} from "moviedb-promise";

// It's very easy to get yourself a key in case you're here thinking you're being smart for using someone else's key
export const tmdbClient = new MovieDb("d966082b253dac6e818d70084d7222cd");
